// utils/discountUtils.js
export const isDiscountActive = (product) => {
  if (!product.discount_percent || product.discount_percent <= 0) {
    return false;
  }
  
  const now = new Date();
  if (product.discount_start_date && now < new Date(product.discount_start_date)) {
    return false;
  }
  if (product.discount_end_date && now > new Date(product.discount_end_date)) {
    return false;
  }
  
  return true;
};

export const calculateDiscountedPrice = (product) => {
  if (isDiscountActive(product)) {
    const discountAmount = product.price * (product.discount_percent / 100);
    return product.price - discountAmount;
  }
  return product.price;
};

export const getDiscountBadge = (product) => {
  if (isDiscountActive(product)) {
    return `-${product.discount_percent}%`;
  }
  return null;
};